import Input from 'components/forms/Input'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import SuperAdminAction from '../actions/SuperAdminAction'
import DtoResult from '../dto/DtoResult'
import { Button, Grid } from '@mui/material'
import DtoPreparedRequest from '../dto/DtoPreparedRequest'
import { exportFile } from '../../../../utils/ExportDataUtil'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import AppStore from '../../../../store/AppStore'
import { nbPerPageLabel } from '../../../../referencial/constants/ReferencialConstants'
import { uniq } from 'lodash'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import NumberField from '../../../../components/forms/NumberField'
import { hasValue } from '../../../../utils/NumberUtil'
import moment from 'moment'
import { CardTable } from 'components/datatable/NewTable'

class SuperAdminReqPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            request: '',
            token: '',
            preparedRequests: [],
            selectedRequest: null,
            number: '',
            name: '',
            description: '',
            results: [],
            resultsHeaders: [],
            params: {},
        }
    }


    execRequest = () => {
        const { request, token } = this.state
        if (request && token) {
            if (request.toUpperCase().startsWith('SELECT')) {
                SuperAdminAction.execSelect(request, token).then(results => {
                    if (!results.resultat.length) {
                        AppStore.dispatch(ToastrAction.info(i18n.noResults))
                    } else {
                        AppStore.dispatch(ToastrAction.success('Requête exécutée avec succès.'))
                    }
                    this.setState({ results: results.resultat, resultsHeaders: request.toLowerCase().split('select')[1].split('from')[0].split(',').map(c => c.trim()) })
                })
            } else {
                SuperAdminAction.execInsertOrUpdate(request, token).then(results => {
                    AppStore.dispatch(ToastrAction.success('Requête exécutée avec succès.'))
                    this.setState({ resultsHeaders: ['Nb de lignes mises à jour'], results: [[results.result]] })
                })
            }
        } else {
            AppStore.dispatch(ToastrAction.info('Veuillez renseigner le token et une requête'))
        }
    }

    componentDidMount() {
        SuperAdminAction.getRequest().then((request) => this.setState({ preparedRequests: request.map((l) => new DtoPreparedRequest(l)) }))
    }

    onExport = (data) => {
        if (data.length) {
            data[0].headers = this.state.resultsHeaders
            exportFile({
                data,
                exportType: 'xlsx',
                titleFile: 'selectExport',
            })
        }
    }

    render() {
        const { preparedRequests, selectedRequest, resultsHeaders, results, params } = this.state
        const data = results.map(r => resultsHeaders.reduce((acc, v, idx) => ({ ...acc, [v]: { value: r[idx] } }), {}))
        const parameters = selectedRequest?.request ? uniq(selectedRequest?.request.toLowerCase().match(/#[a-z]\$[a-zA-Z]+#/g)).map((param, idx) => {
            const [inputType, name] = param.replaceAll('#', '').split('$')
            if (inputType === 'd') {
                return (
                    <SimpleDatePicker
                        key={idx}
                        value={params[name]}
                        label={name}
                        onChange={(value) => this.setState({ params: { ...this.state.params, [name]: value } })}
                    />
                )
            }
            if (inputType === 'i' || inputType === 'f') {
                return (
                    <NumberField
                        key={idx}
                        title={name}
                        floatValue={inputType === 'f'}
                        value={params[name]}
                        onChange={(value) => this.setState({ params: { ...this.state.params, [name]: value } })}
                    />
                )
            }
            return (
                <Input
                    key={idx}
                    title={name}
                    value={params[name]}
                    onChange={(value) => this.setState({ params: { ...this.state.params, [name]: value } })}
                />
            )
        }) : []
        return (
            <Grid container spacing={2}>
                <Grid size={12} container>
                    <Grid size={4}>
                        <Select
                            value={this.state.selectedRequest?.id}
                            options={preparedRequests}
                            label='Requête préparée'
                            onChange={(e) => this.setState({ selectedRequest: preparedRequests.find(r => r.id === e) })}
                        />
                    </Grid>
                    <Button
                        style={{ marginTop: 10 }}
                        onClick={() => {
                            if (selectedRequest) {
                                const paramsUniq = uniq(selectedRequest?.request.toLowerCase().match(/#[a-z]\$[a-zA-Z]+#/g))
                                const updatedRequest = paramsUniq.reduce((acc, value) => {
                                    const [inputType, name] = value.replaceAll('#', '').split('$')
                                    if (hasValue(params[name])) {
                                        if (inputType === 'd') {
                                            return acc.replaceAll(value, `\'${moment(params[name]).format('YYYY-MM-DD HH:mm:ss')}\'`)
                                        }
                                        return acc.replaceAll(value, params[name])
                                    } return acc
                                }, selectedRequest.request)

                                this.setState({ request: updatedRequest })
                            }
                        }}
                        variant='contained'
                    >
                        {i18n.apply}
                    </Button>
                </Grid>
                <Grid size={12}>
                    <h6>{ selectedRequest?.description }</h6>
                </Grid>
                {parameters.length ? (
                    <StyledFieldSet>
                        <StyledLegend>&nbsp;{i18n.parameters}&nbsp;</StyledLegend>
                        {parameters}
                    </StyledFieldSet>
                ) : null}
                <Textarea
                    title={i18n.request}
                    value={this.state.request}
                    onChange={v => this.setState({ request: v })} row={12} col={12}
                />
                <Grid size={12}>
                    <Button
                        style={{ marginTop: 10 }}
                        onClick={this.execRequest}
                        variant='contained'
                    >
                        {i18n.execute}
                    </Button>
                    <Input
                        col={2}
                        title={i18n.token}
                        floatValue={false}
                        obligatory
                        value={this.state.token}
                        onChange={(e) => this.setState({ token: e })}
                    />
                </Grid>
                {data.length ? (
                    <CardTable
                        title={i18n.results}
                        rows={data}
                        headers={resultsHeaders}
                        customHeaders={ resultsHeaders.reduce((acc, h) => ({ ...acc, [h]: h }), {}) }
                        actions={[{ icon: 'file_download', tooltip: i18n.export, onClick: () => this.onExport(data) }]}
                        rowsPerPageOptions={nbPerPageLabel}
                    />
                ) : null}
            </Grid>
        )
    }
}

SuperAdminReqPanel.propTypes = {
    result: PropTypes.arrayOf(PropTypes.instanceOf(DtoResult)),
}

export default SuperAdminReqPanel
